<template>
	<div>
		<div>
			<div class="t">
				<el-menu class="el-menu-demo" mode="horizontal"
					background-color="#67C23A" text-color="#fff" active-text-color="#ffd04b">
					<el-submenu index="1">
						<template v-if="pharseName == ''" slot="title">当前：选择科目</template>
						<template v-else slot="title">当前：{{ pharseName }}{{ subjectName }}</template>

						<div class="title">
							<div class="tet" v-for="(item,index) in arr" :key="index">{{ item.grade.name }}
								<div class="p_flex p_f_1 heade_center tit">
									<div v-for="(item1,index1) in item.subject" :key="index1" class="p_m_l_10 p_m_t_10">
										<el-button @click="goHeaderindexss(item,item1.name)" type="info" round
											size="mini">{{
								  						item1.name
								  					}}
										</el-button>
									</div>
								</div>
							</div>
						</div>
					</el-submenu>
					<el-menu-item index="2" @click="goSelect('/Layout')">布置作业</el-menu-item>
					<el-menu-item index="3" @click="goSelect('/Select')">制作习题</el-menu-item>
					<el-menu-item index="4" @click="goSelect('/Mine')">我的题库</el-menu-item>
					<el-menu-item index="5" @click="goSelect('/Mine?id=1')">校本题库</el-menu-item>
					<el-menu-item index="6" @click="goSelect('/Sent')">已发作业</el-menu-item>
					<el-menu-item index="7" @click="goSelect('/Correct')">待批改作业</el-menu-item>
					<el-menu-item index="8" @click="goSelect('/Perform')">已完成作业</el-menu-item>
					<el-menu-item index="9" @click="goSelect('/Analyse')">作业分析报告</el-menu-item>
					<el-menu-item index="10" @click="goSelect('/Wrong')">错题批改</el-menu-item>
				</el-menu>
			</div>
		</div>
		<div class="top" v-if="pharseName!=''">
			<div class="p_flex">
				<span class="p_m_t_10 head" style="margin-top: 15px;">年级：</span>
				<div class="p_flex p_f_1 heade_center ">
					<div class="p_m_l_10 p_m_t_10" v-for="(item,index) in arrs" :key='index'>
						<el-button @click="goHeaderindexs(item)" :type="headerindexs==item.id?'success':'info'" round
							size="mini">{{ item.name }}
						</el-button>
					</div>
				</div>
			</div>
			<el-divider style="margin-bottom: -50px;"></el-divider>
			<div class="p_flex">
				<span class="p_m_t_10 head" style="margin-top: 15px;">教材版本：</span>
				<div class="p_flex p_f_1 heade_center ">
					<div class="p_m_l_10 p_m_t_10" v-for="(item,index) in arrsss" :key='index'>
						<el-button @click="goHeaderindexsss(item)" :type="headerindexsss==item.id?'success':'info'"
							round size="mini">{{ item.name }}
						</el-button>
					</div>
				</div>
			</div>
		</div>
		<div class="container" v-if="pharseName!=''">
			<div class="left" style="height:200px">
				<div class="p_flex">
					<div class="p_flex p_f_1 heade_center ">
						<el-tree class="p_m_l_10 p_m_t_10" :data="arrssss" :props="defaultProps" accordion
							@node-click="goHeaderindexssss">
						</el-tree>
					</div>
				</div>
			</div>
			<div class="right">
				<div class="p_flex">
					<span class="p_m_t_10 head" style="margin-top: 15px;">题型：</span>
					<div class="p_flex p_f_1 heade_center ">
						<div class="p_m_l_10 p_m_t_10" v-for="(item,index) in arrsssss" :key='index'>
							<el-button @click="goHeaderindexsssss(item.ids)"
								:type="headerindexsssss==item.ids?'success':'info'" round size="mini">
								{{ item.typeName }}
							</el-button>
						</div>
					</div>
				</div>
				<el-divider></el-divider>
				<div class="p_flex">
					<span class="p_m_t_10 head" style="margin-top: 15px;">难易程度：</span>
					<div class="p_flex p_f_1 heade_center ">
						<div class="p_m_l_10 p_m_t_10" v-for="(item,index) in arrssssss" :key='index'>
							<el-button @click="goHeaderindexssssss(item.ids)"
								:type="headerindexssssss==item.ids?'success':'info'" round size="mini">{{
									item.name
								}}
							</el-button>
						</div>
					</div>
				</div>
				<!-- <el-divider></el-divider>
				<div class="p_flex heades">
					<span class="p_m_t_10 head" style="margin-top: 15px;">时间：</span>
					<div class="p_flex p_f_1 heade_center ">
						<div class="p_m_l_10 p_m_t_10" v-for="(item,index) in arrsssssss" :key='index'>
							<el-button @click="goHeaderindexsssssss(item.id)"
								:type="headerindexsssssss==item.id?'success':'info'" round size="mini">{{
									item.name
								}}
							</el-button>
						</div>
					</div>
				</div> -->
				<el-divider></el-divider>
				<div class="p_flex" style="margin-bottom: 20px;">
					<span class="p_m_t_10 head" style="margin-top: 15px;">题类筛选：</span>
					<div class="p_flex p_f_1 heade_center ">
						<div class="p_m_l_10 p_m_t_10" v-for="(item,index) in arrssssssss" :key='index'>
							<el-button @click="goHeaderindexssssssss(item.ids)"
								:type="headerindexssssssss==item.ids?'success':'info'" round size="mini">{{
									item.name
								}}
							</el-button>
						</div>
					</div>
				</div>
				<!-- <el-divider></el-divider>
				<div class="p_flex" style="margin-bottom: 20px;">
					<span class="p_m_t_10 head" style="margin-top: 15px;">地区：</span>
					<div class="p_flex p_f_1 heade_center ">
						<div class="p_m_l_10 p_m_t_10" v-for="(item,index) in arrsssssssss" :key='index'>
							<el-button @click="goHeaderindexssssssss(item.ids)"
								:type="headerindexsssssssss==item.ids?'success':'info'" round size="mini">{{
									item.name
								}}
							</el-button>
						</div>
					</div>
				</div> -->
			</div>
		</div>
	</div>
</template>


<script>
	export default {
		data() {
			return {
				//切换
				radio: '1',
				num: 0, //学科id初始化
				gradnum: 0, //年级id初始化
				questionTypenum: 0, //题型id初始化
				pharseCode: '', //学段Code
				pharseId: '', //学段id
				pharseName: '',
				headerindex: 0, //学段
				gradeId: '', //年级id
				gradeCode: '',
				headerindexs: 0, //年级
				subjectCode: '', //学科Code
				subjectId: '', //学科id
				subjectName: '', //学科
				headerindexss: 0, //学科
				editionId: '', //教材版本id
				editionCode: '',
				headerindexsss: 0, //教材版本
				knowledgeId: '', //知识点id
				questionTypeId: '', //题型id
				headerindexsssss: 0, //题型
				diffTypeId: '', //难易程度id
				headerindexssssss: 0, //难易程度
				datetime: '', //时间
				headerindexsssssss: 0, //时间
				testPaperTypeId: '', //题类id
				headerindexssssssss: 0, //题类筛选
				headerindexsssssssss:0,//地区
				arr: [], //学段
				arrs: [], //年级
				arrss: [], //学科
				arrsss: [], //教材版本
				arrssss: [], //知识点
				arrsssss: [], //题型
				arrssssss: [], //难易程度
				arrsssssss: [], //时间
				arrssssssss: [], //题类筛选
				arrsssssssss:[],//地区
				defaultProps: {
					label: "name",
					children: "child"
				}
			};
		},
		//监听radio变化
		watch: {
			subjectCode() {
				/* if (this.subjectName == '语文' || this.subjectName == '英语') {
					if (this.editionCode) {
						this.getKnowledge1()
					}
				} else {
					this.getKnowledge2()
				} */
				this.getKnowledge1()
			},
			editionCode() {
				this.getKnowledge1()
				/* if (this.subjectName == '语文' || this.subjectName == '英语') {
					if (this.editionCode) {
						this.getKnowledge1()
					}
				} else {
					this.getKnowledge2()
				} */
			}
		},
		created() {
			this.$request.ajax(this).post("/admin.QuestionBasicinformation/getPharseAndSubject").then(res => { //学段
				this.arr = res.data
			})
			this.$request.ajax(this).get("/Library/diffType").then(res => { // 难易程度
				this.arrssssss = res.data

				this.arrssssss.unshift(...[{
					id: 0,
					name: "全部"
				}])
				this.arrssssss.forEach((value, index) => {
					value.ids = index
				})
				this.diffTypeId = this.arrssssss[0].id
			})
			// 时间
			const date = new Date();
			let timeList = []
			let i = 0
			for (let time = date.getFullYear(); time >= date.getFullYear() - 10; time--) {
				let obj = {}
				obj.id = i + 1
				obj.name = time
				timeList.push(obj)
				i++
			}
			this.arrsssssss = timeList
			this.arrsssssss.unshift(...[{
				id: 0,
				name: "全部"
			}])
			// this.datetime = this.arrsssssss[0].name
			this.$request.ajax(this).post("/Library/testPaperType").then(res => { // 题类筛选
				this.arrssssssss = res.data
				this.arrssssssss.unshift(...[{
					id: 0,
					name: "全部"
				}])
				this.arrssssssss.forEach((value, index) => {
					value.ids = index
				})
				this.testPaperTypeId = this.arrssssssss[0].id
			})
		},
		methods: {
			goSelect(path) {
				this.$router.push(path);
			},
			//获取年级
			getGrad() {
				this.$request.ajax(this).post("/admin.QuestionBasicinformation/getGradeAndEdition", {
					pharseId: this.pharseId,
					subjectName: this.subjectName
				}).then(res => { //年级
					this.arrs = res.data.grade
					res.data.grade.forEach((value, index) => {
						if (value.id == res.data.subject.pid) {
							this.gradeId = value.id
							this.gradeCode = value.code
							this.$emit('headerindexs', this.gradeCode)
							localStorage.removeItem('gradeName')
							localStorage.setItem('gradeName', JSON.stringify(value.name))
							// this.arrsss = res.data.edition
							// this.headerindexsss = res.data.edition[0].id
							// res.data.edition.forEach((value1, index1) => {
							// 	this.editionId = value1.id
							// 	this.editionCode = value1.code
							// 	this.$emit('headerindexsss', this.editionCode)
							// })
							if (res.data.edition.length == 0) {
								this.arrsss = [{
									code: "",
									id: "0",
									name: "默认教材",
									pid: "",
								}]
							}
							this.headerindexsss = res.data.edition[0].id
							this.arrsss = res.data.edition
							this.editionId = this.arrsss[0].id
							this.editionCode = this.arrsss[0].code
							this.$emit('headerindexsss', this.editionCode)
						}
					})
					this.subjectCode = res.data.subject.code
					this.headerindexs = res.data.subject.pid
					this.$emit('headerindexss', this.subjectCode)
					this.getTestPaperTypes()
				})
			},
			//获取教材版本
			getVersion() {
				this.$request.ajax(this).post("/admin.QuestionBasicinformation/getEdtion", {
					gradeId: this.gradeId,
					subjectName: this.subjectName
				}).then(res => { //教材版本
					if (res.data.length == 0) {
						this.arrsss = [{
							code: "",
							id: "0",
							name: "默认教材",
							pid: "",
						}]
					}
					this.headerindexsss = res.data.edition[0].id
					this.arrsss = res.data.edition
					this.editionId = res.data.edition[0].id
					this.editionCode = res.data.edition[0].code
					this.$emit('headerindexsss', this.editionCode)

					this.getKnowledge1()
				})
			},
			//获取知识点章节
			getKnowledge1() {
				let data = {}
				data.pharseId = this.pharseCode
				data.subjectId = this.subjectCode
				data.editionId = this.editionCode
				data.gradeId = this.gradeCode
				this.$request.ajax(this).post("/admin.QuestionKnow/list", data).then(res => { // 知识点
					this.arrssss = res.data
					let obj = {}
					obj.pharseId = this.pharseCode
					obj.subjectId = this.subjectCode
					obj.editionId = this.editionCode
					obj.gradeId = this.gradeCode
					obj.diffTypeId = this.diffTypeId
					obj.paperType = this.testPaperTypeId
					obj.knowledgeId = this.knowledgeId
					//localStorage.removeItem('initData')
					localStorage.setItem('initData', null)
					localStorage.setItem('initData', JSON.stringify(obj))
				})
			},
			//获取知识点树
			getKnowledge2() {
				let data = {}
				data.pharseId = this.pharseCode
				data.subjectId = this.subjectCode
				this.$request.ajax(this).post("/admin.QuestionKnow/list", data).then(res => { // 知识点
					this.arrssss = res.data
					let obj = {}
					obj.pharseId = this.pharseCode
					obj.subjectId = this.subjectCode
					obj.editionId = this.editionCode
					obj.gradeId = this.gradeCode
					obj.diffTypeId = this.diffTypeId
					obj.paperType = this.testPaperTypeId
					obj.knowledgeId = this.knowledgeId
					//localStorage.removeItem('initData')
					localStorage.setItem('initData', null)
					localStorage.setItem('initData', JSON.stringify(obj))
				})
			},
			//获取题型
			getTestPaperTypes() {
				this.$request.ajax(this).post("/admin.QuestionType/list", {
					subjectId: this.subjectCode,
					pharseId: this.pharseCode
				}).then(res => { // 题型
					res.data.unshift(...[{
						id: 0,
						typeName: "全部"
					}])
					res.data.forEach((value, index) => {
						value.ids = index
					})
					this.arrsssss = res.data
					if (this.questionTypenum == 0) {
						this.questionTypeId = this.arrsssss[0].id
						this.questionTypenum++
					}
				})
			},
			// //学段点击获取id
			// goHeaderindex(i) {
			// 	this.headerindex = i
			// 	this.pharseId = this.arr[i].id
			// 	this.pharseCode = this.arr[i].code
			// 	console.log(this.pharseCode)
			// 	this.$emit('Headerindex', this.pharseCode);
			// 	this.getGrad()
			// },
			//年级点击获取id
			goHeaderindexs(item) {
				this.headerindexs = item.id
				this.gradeId = item.id
				this.gradeCode = item.code
				localStorage.removeItem('gradeName')
				localStorage.setItem('gradeName', JSON.stringify(item.name))
				this.$emit('headerindexs', this.gradeCode)
				this.getVersion()
			},
			//学科点击获取id
			goHeaderindexss(item, name) {
				this.pharseName = item.grade.name
				this.pharseId = item.grade.id
				this.pharseCode = item.grade.code
				this.subjectName = name
				this.$emit('Headerindex', this.pharseCode);
				localStorage.removeItem('subjectName')
				localStorage.setItem('subjectName', JSON.stringify(name))
				this.getGrad()
			},
			//教材版本点击获取id
			goHeaderindexsss(item) {
				this.headerindexsss = item.id
				this.editionId = item.id
				this.editionCode = item.code
				console.log(this.editionCode)
				this.$emit('headerindexsss', this.editionCode)
			},
			//知识点点击获取id
			goHeaderindexssss(data) {
				let chapterId = data.id
				this.knowledgeId = data.oldId;
				this.$emit('headerindexssss', {
					knowledgeId: this.knowledgeId,
					chapterId: chapterId
				})
			},
			//题型点击获取id
			goHeaderindexsssss(i) {
				this.headerindexsssss = i
				this.questionTypeId = this.arrsssss[i].id
				console.log(this.questionTypeId)
				this.$emit('headerindexsssss', this.questionTypeId)
			},
			//难易程度点击获取id
			goHeaderindexssssss(i) {
				this.headerindexssssss = i
				this.diffTypeId = this.arrssssss[i].id
				console.log(this.diffTypeId)
				this.$emit('headerindexssssss', this.diffTypeId)
			},
			//时间点击获取id
			goHeaderindexsssssss(i) {
				this.headerindexsssssss = i
				this.datetime = this.arrsssssss[i].name
				if (this.arrsssssss[i].id == 0) {
					this.datetime = 0;
				}
				console.log(this.datetime)
				this.$emit('headerindexsssssss', this.datetime)
			},
			//题类筛选点击获取id
			goHeaderindexssssssss(i) {
				this.headerindexssssssss = i
				this.testPaperTypeId = this.arrssssssss[i].id
				console.log(this.testPaperTypeId)
				this.$emit('headerindexssssssss', this.testPaperTypeId)
			}

		}
	};
</script>

<style lang="scss" scoped>
	.tit {
		width: 280px;
	}

	.title {
		width: 300px;
		border: 1px solid #a6a9ad;
		position: absolute;
		background-color: #fff;

		.el-button:hover {
			background-color: #e54c00;
			color: #FFF;
		}
	}

	.tet {
		margin-top: 10px;
		width: 200px;
		padding-left: 20px;
	}

	.t>.title {
		z-index: 999999;
		display: none;
	}

	.t {
		position: relative;
		//width: 300px;
		height: 30px;
		line-height: 30px;
		border: 0px solid #a6a9ad;
	}

	.t:hover .title {

		display: block;
		background-color: #fff;
	}

	.top {
		padding-left: 50px;
		background-color: #fafafa;
		border-radius: 5px;
		margin-top: 30px;
	}

	.container {
		margin-top: 20px;
		display: flex;


		.left {
			width: 25%;
			border-radius: 5px;
			overflow: auto;
			white-space: nowrap;
			height: 20%;
			border: rgba(215, 214, 214, 0.64) 1px solid;

			&-top {
				display: flex;
				justify-content: center;
			}
		}

		.right {
			width: 75%;
			height: 20%;
			margin-left: 10px;
			border-radius: 5px;
			border: rgba(215, 214, 214, 0.64) 1px solid;
			padding-left: 20px;
		}
	}

	.heades {
		padding: 0 0 10px;
	}

	.heade_center {
		flex-wrap: wrap;
	}

	>>>.el-button--info {
		color: #4D4D4D;
		border: #FFFFFF;
		background-color: #FFFFFF;
	}

	.head {
		// padding-top: 5px;
	}

	.p_m_t_10 {
		margin-top: 10px;
	}

	>>>.el-button--mini,
	.el-button--mini.is-round {
		padding: 5px 10px;
	}

	.el-divider--horizontal {
		display: block;
		height: 1px;
		width: 96%;
		margin: 15px 0px 5px 0px;
	}

	.el-button--success {
		background-color: #e54c00;
		border: #e54c00 1px solid;
	}
</style>



// WEBPACK FOOTER //
// src/components/homet/commponents/huiquestionHeader.vue